import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import Utils from "../shared/utilerias/utils";
import { User } from '../entidades/entidades';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
     
        if (!this.currentUserSubject) {
            this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
            this.currentUser = this.currentUserSubject.asObservable();
        }
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string, token: string, isNotMovil:boolean = true) {
        return this.http.post<any>(`${Utils.getBaseUrlApiWeb()}/users/authenticate`, { username, password, token, isNotMovil })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.currentUserSubject.next(user);
                return user;
            }));
    }

   async  logout(Token) {
        if(Token == null || Token == "" )
            return;

             var username: string = "tr";
             var password: string = "tr";
     await    this.http
            .post<any>(`${Utils.getBaseUrlApiWeb()}/users/logout`, {
                username,
                password,
                Token,
            }).toPromise();
    }
    deleteLocalStorage() {
        localStorage.removeItem("currentUser");
        this.currentUserSubject.next(null);
    }
    
    async getUserByToken() {

        var username: string = "tr";
        var password: string = "tr";
        var token: string = JSON.parse(localStorage.getItem("currentUser")).token;

        if (this.currentUserValue.id == 0) {
            return await (this.http.post<User>(`${Utils.getBaseUrlApiWeb()}/users/getUserByToken`, { username, password, token })
                .pipe(map(user => {
                    this.currentUserSubject.next(user);
                    return user;
                }))).toPromise();
        } else
            return this.currentUserSubject;
    }
}